// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const unown: PokeData = {
  "id": 201,
  "name": "unown",
  "height": 5,
  "weight": 50,
  "base_experience": 118,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "hidden-power"
  ],
  "moves": [
    "reflect",
    "psy-pulse",
    "healing-wish",
    "psychic",
    "psywave",
    "psy-ball",
    "psychic-terrain",
    "zen-headbutt",
    "kinesis",
    "calm-mind",
    "synchronize",
    "future-sight",
    "psychic-fangs"
  ],
  "evolution_chain": {
    "id": 99,
    "item": null,
    "species": [
      {
        "name": "unown",
        "order": 231,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 96,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
